import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_PRODUCT_LISTING,
    GET_PRODUCT_LISTING_FOR_GIFT,
    GET_PRODUCT_LISTING_FOR_ACCESORIES,
    ADD_PRODUCT,
    UPDATE_PRODUCT,
    APPROVE_REJECT_PRODUCT,
    DELETE_PRODUCT,
    DELETE_BULK_PRODUCT,
    EXPORT_PRODUCT,
    IMPORT_PRODUCT,
    IMPORT_PRODUCT_IMAGE,
    GET_PRODUCT_DETAILS,
    PRE_ADD_DATA,
    BULK_ATTACH_PDF,
} from "./actionTypes.js";

import {
    getProductListingSuccess,
    getProductListingFail,
    getProductListingForGiftSuccess,
    getProductListingForGiftFail,
    getProductListingForAccessoriesSuccess,
    getProductListingForAccessoriesFail,
    createProductSuccess,
    createProductFail,
    approveRejectProductSuccess,
    approveRejectProductFail,
    updateProductSuccess,
    updateProductFail,
    deleteProductSuccess,
    deleteProductFail,
    deleteBulkProductSuccess,
    deleteBulkProductFail,
    exportProductSuccess,
    exportProductFail,
    importProductSuccess,
    importProductFail,
    importProductImageSuccess,
    importProductImageFail,
    getProductDetailsSuccess,
    getProductDetailsFail,
    preAddDataSuccess,
    preAddDataFail,
    bulkAttachPdfSuccess,
    bulkAttachPdfFail,
} from "./actions.js";

import {
    productListingApi,
    productListingForGiftApi,
    productListingForAccessoriesApi,
    productDetailsApi,
    addProductApi,
    updateProductApi,
    approveRejectProductApi,
    deleteProductApi,
    deleteBulkProductApi,
    exportProductApi,
    importProductApi,
    importProductImagesApi,
    bulkAttachPdfApi,
} from "./productApi.js";

function* fetchProductListing({ payload }) {
    try {
        const response = yield call(productListingApi, payload);
        yield put(getProductListingSuccess(response));
    } catch (error) {
        yield put(getProductListingFail(error));
    }
}

function* fetchProductListingForAccessories({ payload }) {
    try {
        const response = yield call(productListingForAccessoriesApi, payload);
        yield put(getProductListingForAccessoriesSuccess(response));
    } catch (error) {
        yield put(getProductListingForAccessoriesFail(error));
    }
}

function* fetchProductListingForGift({ payload }) {
    try {
        const response = yield call(productListingForGiftApi, payload);
        yield put(getProductListingForGiftSuccess(response));
    } catch (error) {
        yield put(getProductListingForGiftFail(error));
    }
}

function* fetchProductDetail({ payload }) {
    try {
        const response = yield call(productDetailsApi, payload);
        yield put(getProductDetailsSuccess(response));
    } catch (error) {
        yield put(getProductDetailsFail(error));
    }
}

function* createProduct({ payload }) {
    try {
        const response = yield call(addProductApi, payload);
        yield put(createProductSuccess(response));
    } catch (error) {
        yield put(createProductFail(error));
    }
}

function* approveRejectProduct({ payload }) {
    try {
        const response = yield call(approveRejectProductApi, payload);
        yield put(approveRejectProductSuccess(response));
    } catch (error) {
        yield put(approveRejectProductFail(error));
    }
}

function* preAddProduct({ payload }) {
    try {
        // Directly pass the payload to the reducer
        yield put(preAddDataSuccess(payload));
    } catch (error) {
        yield put(preAddDataFail(error));
    }
}

function* updateProduct({ payload }) {
    try {
        const response = yield call(updateProductApi, payload);
        yield put(updateProductSuccess(response));
    } catch (error) {
        yield put(updateProductFail(error));
    }
}

function* deleteProduct({ payload }) {
    try {
        const response = yield call(deleteProductApi, payload);
        yield put(deleteProductSuccess(response));
    } catch (error) {
        yield put(deleteProductFail(error));
    }
}

function* deleteBulkProduct({ payload }) {
    try {
        const response = yield call(deleteBulkProductApi, payload);
        yield put(deleteBulkProductSuccess(response));
    } catch (error) {
        yield put(deleteBulkProductFail(error));
    }
}

function* exportProduct({ payload }) {
    try {
        const response = yield call(exportProductApi, payload);
        yield put(exportProductSuccess(response));
    } catch (error) {
        yield put(exportProductFail(error));
    }
}

function* importProduct({ payload }) {
    try {
        const response = yield call(importProductApi, payload);
        yield put(importProductSuccess(response));
    } catch (error) {
        yield put(importProductFail(error));
    }
}

function* importProductImage({ payload }) {
    try {
        const response = yield call(importProductImagesApi, payload);
        yield put(importProductImageSuccess(response));
    } catch (error) {
        yield put(importProductImageFail(error));
    }
}

function* bulkAttachPdf({ payload }) {
    try {
        const response = yield call(bulkAttachPdfApi, payload);
        yield put(bulkAttachPdfSuccess(response));
    } catch (error) {
        yield put(bulkAttachPdfFail(error));
    }
}

function* ProductSaga() {
    yield takeEvery(GET_PRODUCT_LISTING, fetchProductListing);
    yield takeEvery(PRE_ADD_DATA, preAddProduct);
    yield takeEvery(GET_PRODUCT_LISTING_FOR_GIFT, fetchProductListingForGift);
    yield takeEvery(GET_PRODUCT_LISTING_FOR_ACCESORIES, fetchProductListingForAccessories);
    yield takeEvery(GET_PRODUCT_DETAILS, fetchProductDetail);
    yield takeEvery(ADD_PRODUCT, createProduct);
    yield takeEvery(UPDATE_PRODUCT, updateProduct);
    yield takeEvery(APPROVE_REJECT_PRODUCT, approveRejectProduct);
    yield takeEvery(DELETE_PRODUCT, deleteProduct);
    yield takeEvery(DELETE_BULK_PRODUCT, deleteBulkProduct);
    yield takeEvery(EXPORT_PRODUCT, exportProduct);
    yield takeEvery(IMPORT_PRODUCT, importProduct);
    yield takeEvery(IMPORT_PRODUCT_IMAGE, importProductImage);
    yield takeEvery(BULK_ATTACH_PDF, bulkAttachPdf);

}

export default ProductSaga
